import AcceptTwoFA from 'features/auth/resetPassword/AcceptTwoFA/AcceptTwoFA';
import React from 'react';

export default function AcceptChallengePage() {
  return <AcceptTwoFA />;
}
